import React, { useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import queryString, { ParsedQuery } from 'query-string';

import serverRenderingUtils from 'helpers/serverRenderingUtils';
import { Footer } from 'client/components/Footer';
import { useBrowserSize } from 'client/contexts/BrowserSize';
import { useCurrentUserCtx } from 'client/contexts/CurrentUser';
import { VALID_VIDEO_PARTNERS } from 'client/screens/IntegrationRedirectScreen/constants';
import { INTEGRATION_CONNECTION_MENU_MODE } from './constants';
import { IntegrationConnectionScreenStyles } from './styles';
import {
  FAQ,
  Hero,
  LoginSignUp,
  MeetAnchor,
  Process,
  Video,
} from './components';

// TODO https://anchorfm.atlassian.net/browse/CAST-2784: Remove feature flag logic once it has been on production
// for a beat and successful.
const shouldShowRouteBasedOnEnvionment = () => {
  const origin = serverRenderingUtils.windowUndefined()
    ? serverRenderingUtils.getBaseUrl()
    : window.location.origin;
  return (
    origin &&
    (/localhost/.test(origin) ||
      /development.anchor.fm/.test(origin) ||
      /website-(.+).anchor.fm/.test(origin))
  );
};

// TODO https://anchorfm.atlassian.net/browse/CAST-2753: Turn on feature flag when releasing to production
// TODO https://anchorfm.atlassian.net/browse/CAST-2784: Remove feature flag logic once it has been on production
// for a beat and successful.
export const ENABLE_INTEGRATION_CONNECTION_SCREEN = shouldShowRouteBasedOnEnvionment();

const setReturnToRedirectPath = (data: ParsedQuery<string>) => {
  let partnerIntegrationParams = '';
  if (typeof data.integrationName === 'string') {
    partnerIntegrationParams = queryString.stringify(
      VALID_VIDEO_PARTNERS[data.integrationName].requiredParams.reduce(
        (acc: any, key: string) => {
          return { ...acc, [key]: data[key] };
        },
        {}
      )
    );
  }

  return `videopartner/${data.integrationName}?${encodeURIComponent(
    partnerIntegrationParams
  )}`;
};

// TODO https://anchorfm.atlassian.net/browse/CAST-2888: When connecting the redirect screen,
// Change the "return_to" links to that screen (i.e. ?return_to=%2Fvideopartner%2Friverside)
export function IntegrationConnectionScreen() {
  const { width } = useBrowserSize();
  const { search } = useLocation();
  const integrationData = queryString.parse(decodeURIComponent(search));
  const [
    currentAuthFormView,
    setCurrentAuthFormView,
  ] = useState<INTEGRATION_CONNECTION_MENU_MODE>(
    integrationData.create ? 'create' : 'login'
  );
  const {
    state: { status },
    resetCurrentUser,
  } = useCurrentUserCtx();
  const returnToRedirectPath = setReturnToRedirectPath(integrationData);
  const showHeroLoginSignUpForm = width >= 992;

  // If the user currently exists, we need to reset the user and have them
  // login or sign up.
  if (status === 'success') {
    resetCurrentUser();
  }

  const loginSignUpRef = useRef<HTMLDivElement>(null);
  const scrollToLoginSignUp = (ref: any) =>
    ref.current.scrollIntoView({ behavior: 'smooth' });

  return (
    <>
      <IntegrationConnectionScreenStyles />
      <div className="pageContainer">
        <Hero
          currentAuthFormView={currentAuthFormView}
          loginSignUpRef={loginSignUpRef}
          setCurrentAuthFormView={setCurrentAuthFormView}
          returnToRedirectPath={returnToRedirectPath}
          showHeroLoginSignUpForm={showHeroLoginSignUpForm}
        />
        {!showHeroLoginSignUpForm && (
          <LoginSignUp
            reference={loginSignUpRef}
            currentAuthFormView={currentAuthFormView}
            setCurrentAuthFormView={setCurrentAuthFormView}
            returnToRedirectPath={returnToRedirectPath}
            showHeroLoginSignUpForm={showHeroLoginSignUpForm}
          />
        )}
        <Process />
        <Video
          onClick={() => scrollToLoginSignUp(loginSignUpRef)}
          currentAuthFormView={currentAuthFormView}
        />
        <MeetAnchor />
        <FAQ />
      </div>
      <Footer />
    </>
  );
}
